import { BranchType, SortTypeEnum, WarrantyClaimNoteStatusEnum, WarrantyLogService } from 'api-new/generated';
import { Link, defaultItemsPerPage } from 'components/table/types';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';
import { createLinks } from 'utils/pagination';

export const warrantyLogQueryKey = 'warrantyLogQueryKey';

export type WarrantyLogFilter = {
  fromDate?: string;
  toDate?: string;
  wipNo?: number;
  regNo?: string;
  branch?: BranchType;
  manufacturerId?: number;
  warrantyTypeIds?: number[];
  waStatuses?: number[];
  warrantyLogStatuses?: WarrantyClaimNoteStatusEnum[];
  adminIds?: number[];
  sort?: string;
  order?: SortTypeEnum;
  skipPagination?: boolean;
  page?: number;
  maxCount?: number;
};

const fetchWarrantyLog = async (input: WarrantyLogFilter) => {
  const data = await WarrantyLogService.getWarrantyLog(
    input.fromDate,
    input.toDate,
    input.wipNo,
    input.regNo,
    input.branch,
    input.manufacturerId,
    input.warrantyTypeIds,
    input.waStatuses,
    input.warrantyLogStatuses,
    input.adminIds,
    input.sort,
    input.order,
    input.skipPagination,
    input.page,
    input.maxCount
  );

  const items = data.items || [];
  const pages = Math.ceil((data.count || 0) / defaultItemsPerPage);

  const links: Array<Link> = createLinks(pages, input.page);

  return {
    data: items,
    totalCount: data.count,
    payload: { pagination: { page: input.page || 1, links, items_per_page: defaultItemsPerPage } }
  };
};

export const useWarrantyLogQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  input: WarrantyLogFilter,
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchWarrantyLog>>,
      QueryError,
      Awaited<ReturnType<typeof fetchWarrantyLog>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) => useQuery([warrantyLogQueryKey, ...(queryKey ?? [{ ...input }])], () => fetchWarrantyLog(input), options);
